import React from 'react';
import { CreditCardIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const stack = [{
  label: '6-Volume ALIGNER CASE COMMANDER™',
  value: '$197'
}, {
  label: '5 Exclusive Bonuses',
  value: '$177'
}, {
  label: '30+ Workflow Tools',
  value: '$67'
}];
export function Offer() {
  return <section className="w-full bg-white py-14 md:py-20" aria-labelledby="offer-title" data-id="element-197" data-mp="3a68hflmm269k">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-198" data-mp="3f408kdfflocp">
        <h2 id="offer-title" className="text-center font-display text-[26px] font-black uppercase leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-199" data-mp="3f2fesq0xy9fw">
          Total Value Stack
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy-900/10 bg-mist shadow-card" data-id="element-200" data-mp="3svy9i0yzodxs">
          <ul className="divide-y divide-navy-900/10 px-5 sm:px-7" data-id="element-201" data-mp="1pdph17cq6a9">
            {stack.map(row => <li key={row.label} className="flex items-center justify-between gap-4 py-4" data-id="element-202" data-mp="1klzsb5j0tgj4">
                <span className="text-[14px] font-semibold leading-snug text-navy-900 sm:text-[15px]" data-id="element-203" data-mp="1fmn52jo8m7g0">
                  {row.label}
                </span>
                <span className="shrink-0 font-display text-base font-black text-navy-800/50 line-through" data-id="element-204" data-mp="1bl1zlje18vfu">
                  {row.value}
                </span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between gap-4 bg-navy-900/5 px-5 py-4 sm:px-7" data-id="element-205" data-mp="23e2d8t2p3iz6">
            <span className="font-display text-[12px] font-black uppercase tracking-[0.14em] text-navy-950" data-id="element-206" data-mp="1zch51l13vsvb">
              Total perceived value
            </span>
            <span className="shrink-0 font-display text-xl font-black text-navy-950 line-through" data-id="element-207" data-mp="1pji18vx1fvr4">
              $441 USD
            </span>
          </div>

          <div className="bg-navy-950 px-5 py-8 text-center sm:px-8" data-id="element-208" data-mp="2i98llmp9jtvo">
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.2em] text-brand-400" data-id="element-209" data-mp="2i7xebcwm03zt">
              Today you get everything for just
            </p>
            <p className="mt-2 font-display text-6xl font-black leading-none text-white sm:text-7xl" data-id="element-210" data-mp="363ir30m2nza9">
              $27
              <span className="ml-2 align-middle font-display text-xl font-bold text-brand-100/70" data-id="element-211" data-mp="2scx2qwdumx4z">USD</span>
            </p>

            <div className="mt-5 space-y-2" data-id="element-212" data-mp="2wcea5vcu64cs">
              <p className="flex items-center justify-center gap-2 text-[12px] font-semibold text-brand-100/85 sm:text-[13px]" data-id="element-213" data-mp="2idy3g4ez4dun">
                <CreditCardIcon className="h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-214" data-mp="2nfdp9yoz6oe3" />
                One-time payment · No subscription
              </p>
              <p className="flex items-center justify-center gap-2 text-[12px] font-semibold text-brand-100/85 sm:text-[13px]" data-id="element-215" data-mp="2df4sain5syxn">
                <GlobeIcon className="h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-216" data-mp="7ng68qs1f8uv" />
                Automatic currency conversion — pay in your local currency
              </p>
            </div>

            <div className="mt-7" data-id="element-217" data-mp="1w6u1cusgmasi">
              <CTAButton tone="gold" onDark subtext="Download immediately · Lifetime access · 7-day guarantee" data-id="element-218" data-mp="1s4yy3kqyxnc3" />
            </div>

            <div className="mt-7" data-id="element-219" data-mp="215nf8obns3t7">
              <Countdown data-id="element-220" data-mp="214m3siqqdfay" />
            </div>

            <div className="mt-5" data-id="element-221" data-mp="213kg9esj30cc">
              <ScarcityBar data-id="element-222" data-mp="2fu1r1or1z2lw" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}